import { Modal } from "../../../components"
import { useGeneralAppStore } from "../../../store/generalAppStore"

import { useEffect } from "react";
import { format } from "date-fns";
import L from "leaflet";
import { toast } from "react-toastify";
import { toastOptions } from "../../../config/toast";
import './style.css'


const ModalMapaMCD = ({ infracciones }) => {

    console.log(infracciones)

    const { modals, handlerModal } = useGeneralAppStore();

    useEffect(() => {
        const buildMap = async () => {
            let container = L.DomUtil.get("mapaInfraccion");
            if (container != null) {
                container._leaflet_id = null;
            }

            if (!infracciones || infracciones.length === 0) return;

            // Centrar en la primera infracción
            const map = L.map("mapaInfraccion", { attributionControl: false }).setView(
                [infracciones[0].latitud, infracciones[0].longitud],
                14
            );

            // Agregar capa de mapa
            L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
                minZoom: 11,
                maxZoom: 20,
            }).addTo(map);

            // Agregar marcadores
            infracciones.forEach((infraccion) => {
                const customIcon = L.divIcon({
                    className: 'custom-marker',
                    html: `<div class="marker-content">${infraccion.id}</div>`,
                    iconSize: [30, 30], // tamaño del marcador
                    iconAnchor: [15, 30], // punto que se ancla en la posición
                });

                L.marker([infraccion.latitud, infraccion.longitud], { icon: customIcon }).addTo(map);
            });

            // Ajustar el mapa para que se vean todos los puntos
            const bounds = L.latLngBounds(
                infracciones.map((i) => [i.latitud, i.longitud])
            );
            map.fitBounds(bounds);
        };

        buildMap();
    }, [infracciones]);

    return (
        <>
            <Modal
                title={() => 'mapa'}
                show={modals?.includes('mapa_denuncias')}
                onHide={() => {
                    handlerModal({ modal: false, modalName: "mapa_denuncias" });
                }}
                backdrop="static"
                fullscreen
            >
                <div className="col-12">
                    <span className="fw-bold text-primary " style={{ fontSize: "14px", lineHeight: "10px" }}>Dirección de la infracción: </span>
                    <div id="mapaInfraccion" className="w-100" style={{ height: "900px" }}></div>
                </div>
            </Modal>
        </>
    )
}

export default ModalMapaMCD;